import type { ZudokuConfig } from "zudoku";
import StatusComponent from "./src/Status";

const config: ZudokuConfig = {
  page: {
    logo: {
      src: {
        light: "/logo_black.svg",
        dark: "/logo_white.svg",
      },
    },
  },
  mdx: {
    components: {
      StatusComponent,
    },
  },
  metadata: {
    title: "Corplifting API - %s",
    favicon: "/favicon.svg",
  },
  topNavigation: [
    { id: "docs", label: "Corplifting" },
    { id: "changelog", label: "Changelog" },
    { id: "api", label: "API Reference" },
    { id: "api_status", label: "API Status" },
  ],
  sidebar: {
    docs: [
      {
        type: "category",
        label: "Overview",
        items: ["docs/introduction","docs/modules"],
      },
      {
        type: "category",
        label: "Corplifting API",
        items: ["docs/api","docs/uid","docs/optional_parameters"],
      },
      {
        type: "category",
        label: "Corplifting SDK",
        items: ["docs/sdk/sdk","docs/sdk/sdk_typescript","docs/sdk/sdk_python","docs/sdk/sdk_kotlin","docs/sdk/sdk_csharp"],
      }
      
    ],
    changelog: [
      {
        type: "category",
        label: "Changelog",
        items: ["changelog/2501"],
      },
    ],
    api_status: [
      {
        type: "category",
        label: "API Status",
        items: ["docs/status"],
      },
    ],
  },
  redirects: [{ from: "/", to: "/docs/introduction" }],
  apis: {
    type: "file",
    input: "./apis/openapi.yaml",
    navigationId: "api",
  },
  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};
export default config;